<template><svg width="10" height="6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 6L.67.75h8.66L5 6z" fill="#666"/></svg></template>